export class ShipmentPeriod {

    private starDate: number;
    private endDate: number;

    constructor(
        starDate: number,
        endDate: number
    ) {
        this.starDate = starDate;
        this.endDate = endDate;
    }

    public getStarDate(): number {
        return this.starDate;
    }

    public setStartDate(starDate: number): void {
        this.starDate = starDate;
    }

    public getEndDate(): number {
        return this.endDate;
    }

    public setEndDate(endDate: number): void {
        this.endDate = endDate;
    }

    public isEqual(other: ShipmentPeriod): boolean {
        if (!other) {
            return false;
        }
        return this.starDate === other.getStarDate() && this.endDate === other.getEndDate();
    }

}